import React, { FC, ReactElement } from 'react'
import styles from './ItemGrid.module.css'
import classNames from 'classnames'
import FeedLoadingState from '@/components/feed-loading-state'

const ItemGrid: FC<{
	className?: string
	children: React.ReactNode
	isLoading?: boolean
	disableDefaultLayout?: boolean
}> = (
	props
): ReactElement => {
	if (props?.isLoading) {
		return <FeedLoadingState />
	}

	return (
		<div
			className={classNames(props.className, {
				[styles.root]: !props.disableDefaultLayout
			})}
		>
			{props.children}
		</div>
	)
}

export default ItemGrid
